<script setup>
defineProps({
  image: {
    type: String,
  },
  imageAltText: {
    type: String,
  },
  imageWidth: {
    type: String,
  },
  imageHeight: {
    type: String,
  },
  heading: {
    type: String,
  },
  description: {
    type: String,
  },
  category: {
    type: String,
  },
  categoryUrl: {
    type: String,
  },
  url: {
    type: String,
  },
})
</script>

<!-- Featured Article Card -->
<template>
  <div class="featured-article mb-(--block-spacing)">
    <div class="container-fluid">
      <div class="featured-article__card shadow-xl rounded-xl bg-white 3xl:max-w-block-wide 3xl:m-auto">
        <NuxtImg
          v-if="image"
          provider="fastlyAprimo"
          :src="image"
          class="featured-article-card__image"
          :alt="imageAltText"
          :width="imageWidth ?? 731"
          :height="imageHeight ?? 388"
          loading="lazy"
          quality="90"
        />
        <div class="featured-article-card__content pt-[30px] px-[30px] pb-[45px] lg:pt-[45px] lg:px-[45px] lg:pb-[60px] 2xl:px-[65px] prose">
          <h2 class="h3">
            <ULink
              :to="useCmsUrl(url)"
              :locale="false"
              class="text-primary"
            >
              {{ heading }}
            </ULink>
          </h2>
          <p>{{ description }}</p>
          <ULink
            v-if="categoryUrl"
            :to="useCmsUrl(categoryUrl)"
            :locale="false"
            class=" italic text-med-dark-gray font-normal no-underline"
          >
            {{ category }}
          </ULink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/article-feed-page.scss';
</style>
